import moment from 'moment';
import 'waypoints/lib/noframework.waypoints.min.js';

const messageClassName = 'global-chat-active-chat-messages-container__message'
const globalChatmemberClassName = 'global-chat-active-attendees-list__attendee-item'
const DRAWER_VISIBLE            = 'drawerVisible'
const ACTIVE_TAB                = 'activeTab'
const ACTIVE_CHAT_ROOM_TAB      = 'activeChatroomTab'
const ACTIVE_ROOM_ID            = 'activeRoomId'
const CHAT_ROOM_LIST_ACTIVE_TAB = 'chatRoomListsActiveTab'
var storedStateTypes = {}
storedStateTypes[DRAWER_VISIBLE]            = 'boolean'
storedStateTypes[ACTIVE_TAB]                = 'string'
storedStateTypes[ACTIVE_CHAT_ROOM_TAB]      = 'string'
storedStateTypes[ACTIVE_ROOM_ID]            = 'number'
storedStateTypes[CHAT_ROOM_LIST_ACTIVE_TAB] = 'string'

var storedState = [DRAWER_VISIBLE, ACTIVE_TAB, ACTIVE_CHAT_ROOM_TAB, ACTIVE_ROOM_ID, CHAT_ROOM_LIST_ACTIVE_TAB]

function sortMessagesById (a,b) {
    return a.id - b.id 
}

function sortByFirstName (a, b) {
    var aFirstName = a.attendee_fields && a.attendee_fields.first_name && a.attendee_fields.first_name.toLowerCase()
    var bFirstName = b.attendee_fields && b.attendee_fields.first_name && b.attendee_fields.first_name.toLowerCase()
    return aFirstName > bFirstName ? 1 : -1
}

function attachMomentObjects (message) {
    message.created_at_moment = new moment(message.carbon_created_at)
    return message
}

function GlobalChatController (selector, config) {
      var vueCtrl = new Vue({
      el: selector,

      data: {
          debug: false,
          membersSearch: '',
          drawerVisible: false,
          userOpened: false,
          selectedUserForDirectMessage: null,
          fetchingRooms: false,
          fetchingGlobalRooms: false,
          fetchingModerators: false,
          fetchedRooms: false,
          localStorageAvailable: false,
          activeTab: 'list',
          activeChatroomTab: 'chat',
          chatRoomListsActiveTab: 'groups',
          rooms: [],
          fetchedAttendeeChatRooms: false,
          roomPaginator: {},
          direct_message_rooms: [],
          direct_message_rooms_paginator: [],
          attendeesLastActive: {},
          attendeesOnline: {},
          adminRoomIds: [],
          lastReadMessages: {},
          activeRoomId: null,
          activeChat: null,
          activeChatMessageText: '',
          broadcastChatMessageText: '',
          broadcastChatMessageSending: false,
          broadcastChatRoomsPopupVisible: false,
          fetchingMessages: false,
          fetchingAttendeeList: false,
          newMessageIndicatorPromptVisible: false,
          messageScrollPosition: {
              scrollTop: 0,
              scrollHeight: 0
          },
          initialFetches: {
            direct_messages: false,
            groups: false
          },
          aboveMessageIndicatorWaypoint: false,
          selectedMessage: null,
          alertModal: {
              active: false,
              type: '',
              title: '',
              subtitle: '',
              confirmText: '',
              cancelText: 'Cancel'
          },
          fetchingCreateGlobalChatRoomConnection: false,
          currentEventAttendee: config.currentEventAttendee,
          currentEvent: config.currentEvent,
          blockConnectionFetching: false,
          pinnedMessage: null
      },
      mounted: function () {
          this.getAttendeeChatRooms()
          this.fetchGlobalChatConnections()
          this.listenForAttendeeOnlineUpdates()
          this.listenForDirectMessages()
          this.focusTrap()
          this.$on('flag-unflag-attendee', this.flagUnflagAttendee)
          this.$on('handle-block-toggle', this.handleBlockEventAttendeeToggle)
          this.$on('pin-message', this.pinMessage)
          this.$on('flag-message', this.flagMessage)
          this.$on('direct-message-from-message', this.handleDirectMessageFromMessage)
          this.$on('toggle-blocked-connection-from-message', this.handleToggleBlockedConnectionFromMessage)
          this.$on('get-more-chatrooms', this.getNextAttendeeChatRooms)
          this.$on('get-more-global-direct-chatrooms', this.getNextGlobalDirectChatConnections)
          this.$on('get-more-members', this.getMoreChatRoomMembers)
          this.$on('get-more-messages', this.getMoreMessages)
          this.$on('select-message', this.selectMessage)
          this.$on('scrolled-below-message-waypoint', this.handleChatRoomScrolledBottom)
          this.$on('scrolled-above-message-waypoint', this.handleChatRoomScrolledUp)
          this.$on('handle-delete-connection', this.destroyGlobalChatConnection)
          this.$on('handle-direct-message', this.toggleSelectedUserForDirectMessage)
          this.$on('open-chat', this.openChat)
          this.$on('alert-modal-confirm', this.alertModalConfirm)
          this.$on('alert-modal-cancel', this.alertModalCancel)
          if (document.getElementById('attendee-text-chat-request')) {
            document.getElementById('attendee-text-chat-request').addEventListener('click', function (event) {
                var eventAttendeeId = event.currentTarget.dataset.eventAttendeeId
                this.findOrCreateGlobalChatConnection(eventAttendeeId, true)
            }.bind(this))
          }
          if (document.getElementById('attendee-text-chat-request-mobile')) {
            document.getElementById('attendee-text-chat-request-mobile').addEventListener('click', function (event) {
                var eventAttendeeId = event.currentTarget.dataset.eventAttendeeId
                this.findOrCreateGlobalChatConnection(eventAttendeeId, true)
            }.bind(this))
          }
          window.EventBus.$on('chat-button-clicked', function (eventAttendeeId) {
            this.findOrCreateGlobalChatConnection(eventAttendeeId, true);
           }.bind(this));
      },

      computed: {
          showMessageEmptyState: function () {
            return this.activeChatRoom
                && !this.activeChatRoom.initialFetching
                && !this.fetchingMessages
                && !this.activeChatRoom.messages.length
          },

          ajaxHeaders: function () {
            return {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'Content-Type': 'application/x-www-form-urlencoded',
            }
          },

          orderedMessages: function () {
              if (!this.activeChatRoom || !this.activeChatRoom.messages) return []
              var moderatorIds = this.activeChatRoom.moderators != null 
                ? this.activeChatRoom.moderators.map(m => m.id)
                : []

              this.pinnedMessage = this.activeChatRoom.messages.find(m => m.pinned)

              return this.activeChatRoom.messages.sort(sortMessagesById).map(function setActive (message) {
                var eventAttendeeId = message.event_attendee && message.event_attendee.id
                if (!eventAttendeeId) return message;
                
                var isModerator = moderatorIds.includes(eventAttendeeId)
                message.event_attendee.moderator = isModerator
                return message
              }.bind(this))
          },

          directMessageRecipient () {
            return this.activeChatRoom && 
            this.activeChatRoom.global_chat_connection &&
            this.activeChatRoom.global_chat_connection.other_event_attendee
          },          

          decoratedMembers: function () {
            if (!this.activeChatRoom) return []
            if (!this.activeChatRoom.members) return []
            return this.activeChatRoom.members.map(function (eventAttendee) {
                eventAttendee.moderator = eventAttendee.groups && eventAttendee.groups.length
                return eventAttendee
            }.bind(this)).sort(sortByFirstName)
          },

          activeChatRoom: function () {
            if (this.activeRoomId) return this.rooms.find((room) => room.id == this.activeRoomId)
          },

          activeChatRoomDisplayName: function () {
              if (!this.activeChatRoom) return ''
              if (this.activeChatRoom.global_chat_connection) {
                  var attendeeFields = this.activeChatRoom.global_chat_connection.other_event_attendee
                    && this.activeChatRoom.global_chat_connection.other_event_attendee.attendee_fields

                  if (attendeeFields) {
                      return `${attendeeFields.first_name} ${attendeeFields.last_name}`
                  }
                  return ''
              }
              return this.activeChatRoom.name
          },

          activeChatAdmin: function () {
            if (!this.activeChatRoom) return;
            return this.activeChatRoom.can_moderate
          },

          adminChatRooms: function () {
            return this.rooms.filter(r => r.can_moderate)
          },

          groupChatRooms: function () {
            return this.rooms.filter(function (room) {
                return room.type !== 'direct_message'
            })
          },

          directMessageRooms: function () {
              return this.rooms.filter(function (room) {
                  return room.type === 'direct_message'
              })
          },

          selectedBroadcastChatRooms: function () {
            return this.rooms.filter(r => r.shouldBroadcastToRoom)
          },
      },

      watch: {

          lastReadMessages: {
            handler: function () {
                this.rooms.forEach(this.updateRoomHasUnreadMessage)
            },
            deep: true
          },

          initialFetches: {
              deep: true,
              handler: function () {
                if (!this.initialFetches.direct_messages) return
                if (!this.initialFetches.groups) return
                this.testLocalStorage();
              }
          },

          drawerVisible () {
            // should try to switch to refs, cant seem to v-bind class atm without weird flash to start
            // would prefer to get it there
            // var topNavHeight = $('#nav-top-navigation').outerHeight()
            // if(topNavHeight) $('#attendeeWeb .global-chat').css('padding-top', topNavHeight+'px');
        
            if (this.drawerVisible) {
                $('.navbar-settings__global-chat').addClass('active')
                if ($('.global-chat').hasClass('global-chat_collapsed')) $('.global-chat').removeClass('global-chat_collapsed'); 
                if (this.currentEvent.enable_inline_chat) {
                    if (this.currentEvent.hsbuilder_layout == 'nav_top') {
                        $('.main-content__container').addClass('global-chat__inline-top')
                    } else {
                        $('.main-content__container').addClass('global-chat__inline')
                    }
                }
                if (this.activeRoomId && this[ACTIVE_CHAT_ROOM_TAB] == 'chat') {
                    this.updateLastReadMessageToNewest(this.activeRoomId, {
                        updateRemoteState: true
                    })
                }
            } else {
                if (this.fetchingServerTimeTimeoutId) window.clearTimeout(this.fetchingServerTimeTimeoutId);
                $('.global-chat').addClass('global-chat_collapsed')
                $('.navbar-settings__global-chat').removeClass('active')
                if (this.currentEvent.enable_inline_chat) {
                    if (this.currentEvent.hsbuilder_layout == 'nav_top') {
                        $('.main-content__container').removeClass('global-chat__inline-top')
                    } else {
                        $('.main-content__container').removeClass('global-chat__inline')
                    }
                }

            }
            if (this.localStorageAvailable) localStorage.setItem(DRAWER_VISIBLE, this.drawerVisible);
          },

          chatRoomListsActiveTab () {
              if (this.localStorageAvailable) {
                localStorage.setItem(CHAT_ROOM_LIST_ACTIVE_TAB, this.chatRoomListsActiveTab)
              }
          },

          activeRoomId () {
            if (this.localStorageAvailable) {
                this.activeRoomId
                    ? localStorage.setItem(ACTIVE_ROOM_ID, this.activeRoomId) 
                    : localStorage.removeItem(ACTIVE_ROOM_ID) 
            }
          },

          activeTab () {
              if (this.localStorageAvailable) {
                  this.activeTab
                    ? localStorage.setItem(ACTIVE_TAB, this.activeTab)
                    : localStorage.removeItem(ACTIVE_TAB)
              }
              this.resetNewMessageIndicatorWaypoinState()
          },

          activeChatRoom (newVal, oldVal) {
            if (oldVal && newVal == null) return
            if (oldVal == null && newVal || newVal.id !== oldVal.id) {
                // has active chat room
                this.activeTab = 'chat'
                if (this.activeChatRoom && this.activeChatRoom.type != 'direct_message') {
                    this.listenToRoomNotifications(this.activeChatRoom)
                }
                this.getChatRoomMessages(this.activeChatRoom.id)
                this.fetchGlobalChatRoomModerators(this.activeChatRoom.id)
                this.$nextTick(this.scrollToNewestMessage)
            }
          },

          'activeChatRoom.flagged_attendees' (newVal, oldVal) {
            this.flagMembers()
          },

          activeChatAdmin () {
            if (!this.activeChatRoom) return false;
          },

          activeChatroomTab () {
            if (this.localStorageAvailable) {
                this.activeChatroomTab
                    ? localStorage.setItem(ACTIVE_CHAT_ROOM_TAB, this.activeChatroomTab)
                    : localStorage.removeItem(ACTIVE_CHAT_ROOM_TAB)
            }
            if (this.activeChatroomTab == 'attendees') {
                this.getChatRoomMembers(this.activeChatRoom.id)
                this.resetNewMessageIndicatorWaypoinState()
            }
            if (this.activeChatroomTab == 'chat') {
                this.resetNewMessageIndicatorWaypoinState()
                this.updateLastReadMessageToNewest(this.activeRoomId, {
                    updateRemoteState: true
                })
                if (this.activeRoomId) {
                    this.scrollToNewestMessage()
                }
            }
            if (this.activeChatRoomTab !== 'chat') this.activeChatMessageText = ""
            if (this.activeChatRoomTab !== 'attendees') this.membersSearch = ""
          },

          localStorageAvailable () {
            if (this.localStorageAvailable && !this.userOpened) {
                this.getStateItemsFromStorage()
            }
          },
      },

      methods: {
          getUniqueKey(key, idx) { return `${key}-${idx}`},

          lastReadMessageForRoom (room) {
            return this.lastReadMessages[room.id]
          },

          listenForAttendeeOnlineUpdates () {
            var eventId = this.currentEventAttendee.event_id
            var channelName = `event-attendee-online-bool.event.${eventId}`
            window.Echo.private(channelName).listen('EventAttendeeOnlineUpdated', function (data) {
                var eventAttendee = data.event_attendee
                if (!this.attendeesOnline[eventAttendee.id]) {
                    Vue.set(this.attendeesOnline, eventAttendee.id, eventAttendee.online)
                } else {
                    this.attendeesOnline[eventAttendee.id] = eventAttendee.online
                }
            }.bind(this))              
          },

          flagMembers () {
            if (!this.activeChatRoom) return
            if (!this.activeChatRoom.members) return
            this.activeChatRoom.members = this.activeChatRoom.members.map(function flagMemberIfFlagged (member) {
                member.is_flagged = this.isMemberFlagged(member.id)
                return member
            }.bind(this))
          },

          getStateItemsFromStorage () {
            var storedStates = storedState.reduce(function getItemFromStorage (acc, prop) {
                var val = localStorage.getItem(prop)
                if (val == null) return acc
                var propType = storedStateTypes[prop]
                switch (propType) {
                    case 'string':
                        break;
                    case 'boolean':
                        if (val == "true") {
                            val = true
                        }
                        if (val == "false") {
                            val = false
                        }
                        break;
                    case 'number':
                        val = Number(val)
                    case 'object':
                        val = JSON.parse(val)
                        break;
                    default:
                        console.error(`type not specified for ${prop}`)
                }
                acc[prop] = val
                return acc
            }, {})

            if (!storedStates[DRAWER_VISIBLE]) {
                return
            }

            if (storedStates[ACTIVE_ROOM_ID]) {
                // verify have room otherwise close drawer
                var foundRoom = this.rooms.find(room => room.id == storedStates[ACTIVE_ROOM_ID])
                if (!foundRoom) return;
            } 

            Object.keys(storedStates).forEach(function (prop) {
                this[prop] = storedStates[prop]
            }.bind(this))
          },

          toggleChatDrawerVisible () {
            this.userOpened = true  
            this.drawerVisible = !this.drawerVisible
          },

          getAttendeeChatRooms: function (directMessages=false) {
              this.fetchingRooms = true
              $.ajax({
                  url: '/api/v1/global-chat',
                  headers: this.ajaxHeaders,
                  method: 'GET',
                  success: function (res) {
                      if (res.last_read_messages) {
                        var lastReadMessages = Object.keys(res.last_read_messages).reduce((acc, k) => {
                            acc[k] = Number(res.last_read_messages[k])
                            return acc
                        }, {})
                        this.lastReadMessages = Object.assign({}, lastReadMessages)
                        this.fetchedAttendeeChatRooms = true
                      }
                      res.rooms.data.map(this.decorateRoom).forEach(function (room) {
                        this.rooms.push(room)
                      }.bind(this))
                      this.roomPaginator = res.rooms                      
                      this.fetchingRooms = false
                      this.fetchedRooms = true
                      this.initialFetches.groups = true
                  }.bind(this),
                  error: function (e) {
                      this.fetchingRooms = false
                      this.initialFetches.groups = true
                      console.error('error', e)
                  }.bind(this)
              })
          },

          getNextAttendeeChatRooms: function () {
            var paginator = this.roomPaginator
            if (!paginator) return;
            var nextPageUrl = paginator.next_page_url
            if (!nextPageUrl) return
            if (this.fetchingRooms) return;
            this.fetchingRooms = true
            $.ajax({
                url: nextPageUrl,
                headers: this.ajaxHeaders,
                method: 'GET',
                success: function (res) {
                    var newRooms = res.rooms.data.map(this.decorateRoom)
                    this.rooms = [...this.rooms, ...newRooms]
                    this.roomPaginator = res
                    this.fetchingRooms = false
                    this.fetchedRooms = true
                }.bind(this),
                error: function (e) {
                    this.fetchingRooms = false
                    console.error('error', e)
                }
            })
          },

          fetchGlobalChatRoomModerators: function (id) {
              var room = this.rooms.find(r => r.id === id)
              if (!room) return
              if (this.fetchingModerators) return
              if (room.fetchedModerators) return
              this.fetchingModerators = true

              $.ajax({
                  url: `/api/v1/global-chat/${room.id}/moderators`,
                  headers: this.ajaxHeaders,
                  method: 'GET',
                  success: function (res) {
                    this.fetchingModerators = false
                    room.fetchedModerators = true
                    Vue.set(room, 'moderators', res)
                  }.bind(this),
                  error: function (e) {
                    this.fetchingModerators = false
                    console.error(e)
                  }.bind(this)
              })
          },

          storeLastReadMessages: function () {

            if (!Object.keys(this.lastReadMessages).length) {
                return;
            } 

            $.ajax({
                url: '/api/v1/global_read_chat_messages',
                method: 'POST',
                headers: this.ajaxHeaders,
                data: { last_read_messages: this.lastReadMessages },
                success: function (res) {
                  console.log(res)
                }.bind(this),
                error: function (err) {
                  console.error(err)
                }.bind(this)
            })
          },

          updateRoomHasUnreadMessage (room) {

            if (!this.fetchedAttendeeChatRooms) {
                room.hasUnreadMessage = false
                return room
            }

            if (!room.newestKnownMessageId) {
                room.hasUnreadMessage = false
                return room
            }
            var lastReadMessageId = this.lastReadMessages[room.id]
            if (!lastReadMessageId) {
                room.hasUnreadMessage = true
                return room
            }
            
            if (lastReadMessageId >= room.newestKnownMessageId) {
                room.hasUnreadMessage = false
            } else {
                room.hasUnreadMessage = true
            }
            return room
          },

          decorateRoom (room) {
            room.messages = room.messages.sort(sortMessagesById)
            room.members = []
            room.moderators = []
            room.flaggingInProgressIds = []
            room.fetchedModerators = false
            room.shouldBroadcastToRoom = false
            room.membersPaginator = { fetching: false }
            room.subscribedToPusherChannel = function () {
                return room.pusherChannel
                    && room.pusherChannel.subscription
                    && room.pusherChannel.subscription.subscribed
            }.bind(this)

            room.initialFetching = false

            if (room.type != 'direct_message') {
                room.newMessageChannel = this.listenToNewMessageNotification(room)
            }
            
            room.lastMessage = function () {
                if (!room.messages.length) return null;
                return room.messages[room.messages.length - 1]
            }
            room.newestKnownMessageId = room.lastMessage() && room.lastMessage().id
            room = this.updateRoomHasUnreadMessage(room)
            return room
          },
          goBack() {
            (this.activeChatroomTab == 'attendees') ? this.changeChatroomActiveTab('chat') : this.closeChat()
          },
          openChat(room) {
              this.activeRoomId = room.id
              this.activeTab = 'chat'
              this.activeChatroomTab = 'chat'
          },
          closeChat() {
            if (this.activeChatRoom.pusherChannel && this.activeChatRoom.type != 'direct_message') {
                this.activeChatRoom.pusherChannel.subscription.unsubscribe()
                this.activeChatRoom.newMessageChannel.subscription.subscribe()
            }
            this.updateLastReadMessageToNewest(this.activeRoomId, {
                updateRemoteState: true
            })
            this.activeRoomId = null
            this.activeChatroomTab = 'chat'
            this.activeTab = 'list'
            this.activeChatMessageText = ''
          },
          changeChatroomActiveTab(tab) {
              this.activeChatroomTab = tab
          },

          changeChatRoomListsActiveTab(tab) {
            this.chatRoomListsActiveTab = tab
          },

          storeCurrentScrollPosition () {
              this.messageScrollPosition.scrollHeight = this.$refs.messageholder.scrollHeight;
              this.messageScrollPosition.scrollTop = this.$refs.messageholder.scrollTop;
          },
          applyScrollPosition () {
              this.$refs.messageholder.scrollTop = this.messageScrollPosition.scrollTop +
              (this.$refs.messageholder.scrollHeight - this.messageScrollPosition.scrollHeight);
          },
          getChatRoomMessages (id) {
              this.fetchingMessages = true;
              var room = this.rooms.find(r => r.id === id)
              room.initialFetching = true
              $.ajax({
                  url: `/api/v1/global-chat/${id}/messages`,
                  headers: this.ajaxHeaders,
                  method: 'GET',
                  success: function (res) {
                      this.rooms = this.rooms.map(function appendMessagesToRoom(room) {
                        if (room.id == id) {
                            room.messages = res.data.data.map(attachMomentObjects)
                            room.paginator = res.data
                            room.initialFetching = false
                        }
                        return room
                      }.bind(this))
                      this.$nextTick(function () {
                          this.scrollToNewestMessage()
                          this.fetchingMessages = false;
                      }.bind(this))
                      this.updateLastReadMessageToNewest(room.id, {
                          updateRemoteState: true
                      })
                  }.bind(this),
                  error: function (e) {
                      console.error('error', e)
                      room.initialFetching = false
                  }
              })
          },
          getMoreMessages (id) {
              if (!id) {
                  console.log('no id passed')
                  return
              }
              var room = this.rooms.find(r => r.id === id)
              if (!room) {
                  console.log('no room found')
                  return
              }
              var paginator = room && room.paginator
              if (!paginator) return;
              var nextPageUrl = paginator.next_page_url
              if (!nextPageUrl) return
              if (this.fetchingMessages) return;
              this.fetchingMessages = true
              this.$nextTick(() => {
                  this.storeCurrentScrollPosition()
              })
              $.ajax({
                  url: nextPageUrl,
                  headers: this.ajaxHeaders,
                  method: 'GET',
                  success: function (res) {
                      this.fetchingMessages = false
                      var olderMessages = res.data.data.map(attachMomentObjects)
                      var currMessages = room.messages
                      var messages = [...currMessages, ...olderMessages].sort(sortMessagesById)
                      this.rooms.map(function (currRoom) {
                        if (currRoom.id == room.id) {
                            currRoom.messages = messages
                            currRoom.paginator = res.data
                        }
                        return currRoom
                      }.bind(this))

                      this.$nextTick(function () {
                          this.applyScrollPosition()
                      }.bind(this))
                  }.bind(this),
                  error: function (e) {
                      this.fetchingMessages = false
                      console.error('error', e)
                  }.bind(this)
              })                    
          },

          chatRoomSettingsClick () {
            this.activeChatroomTab = 'settings'
          },

          searchMembers () {
            this.getChatRoomMembers(this.activeRoomId)
          },

          getChatRoomMembers (id) {
              var room = this.rooms.find(r => r.id === id)
              this.fetchingAttendeeList = true;

              var params = {}

              if (this.membersSearch && this.membersSearch.length) {
                  params = Object.assign(params, {search: this.membersSearch})
              }

              $.ajax({
                  url: '/api/v1/global-chat/'+id+'/members',
                  data: {search: this.membersSearch},
                  method: 'GET',
                  data: params,
                  success: function (res) {
                      room.members = res.data.data
                      room.membersPaginator = Object.assign({}, room.membersPaginator, res.data)
                      this.flagMembers()
                      this.$forceUpdate()
                      this.fetchingAttendeeList = false;
                  }.bind(this),
                  error: function (e) {
                      console.error('error', e)
                  }
              })
          },
          getMoreChatRoomMembers(id) {
            if (!id) return
            var room = this.rooms.find(r => r.id === id)
            if (!room) return
            var nextPageUrl = room && room.membersPaginator && room.membersPaginator.next_page_url
            if (!nextPageUrl) return;
            if (room.membersPaginator.fetching) return;
            room.membersPaginator.fetching = true
            // in case changes during fetch
            // var roomId = this.activeChatRoom.id
            $.ajax({
                url: nextPageUrl,
                headers: this.ajaxHeaders,
                method: 'GET',
                success: function (res) {
                    room.members = [...room.members, ...res.data.data]
                    room.membersPaginator = Object.assign({}, {fetching: false}, res.data)
                    this.flagMembers()
                    this.$forceUpdate()
                }.bind(this),
                error: function (e) {
                    room.membersPaginator.fetching = false
                    console.error('error', e)
                }
            })
          },
          updateparentactivechatmessage(text){
            var self = this;
            self.activeChatMessageText = text;
          },

          postMessage() {
              if (!this.activeChatMessageText) {
                  return;
              } else if (this.activeChatMessageText == "\n"){
                  this.activeChatMessageText = '';
                  return;
              }
              var room = this.rooms.find(r => r.id === this.activeRoomId)
              var postData = { message: this.activeChatMessageText }

              if (room.global_chat_connection) {
                postData = Object.assign(postData, { recipient_id: room.global_chat_connection.other_event_attendee.id})
              }
              this.activeChatMessageText = ''
              $.ajax({
                  url: `/api/v1/global-chat/${room.id}/message`,
                  headers: this.ajaxHeaders,
                  data: { 'data': postData },
                  method: 'POST',
                  success: function (res) {
                      if (res.status == 'flagged') {
                          room.flagged_attendees.push(this.currentEventAttendee.id)
                      } else {
                        if (room.messages.find(m => m.id == res.data.id)) {
                            // websocket beat response
                            return
                        }
                        var updatedMessage = attachMomentObjects(res.data)
                        room.messages.unshift(updatedMessage)
                        this.scrollToNewestMessage()
                        this.$refs.chatmessage.$el.style.height = 'auto';
                        this.updateLastReadMessageToNewest(this.activeRoomId, {
                            updateRemoteState: true
                        })
                      }
                  }.bind(this),
                  error: function (e) {
                      if (e.status == 403) {
                          var errMessage = e.responseJSON && e.responseJSON.message
                          if (errMessage) {
                            this.$toasted.error(errMessage, {duration: 3000})
                            return
                          }
                      }
                      if (e.status == 409) {
                          if (e.responseJSON && e.responseJSON.errors) {
                            var errMessage = Object.keys(e.responseJSON.errors).reduce(function (acc, key) {
                                acc = acc + " " + e.responseJSON.errors[key]
                                return acc
                            }.bind(this), '')
                            this.$toasted.error(errMessage, {duration: 3000})
                            return
                          }
                      }
                      if (e.status == 429) {
                          var retryMessage
                          var retryAfter = e.getResponseHeader('retry-after')
                          if (retryAfter) retryMessage = 'Retry after ' + retryAfter + ' seconds'
                          var message = e.responseJSON && e.responseJSON.message
                          if (message && retryMessage) {
                            message = message + '. ' + retryMessage
                          } else if (!message && retryAfter) {
                            message = retryMessage
                          } else {
                              message = "Too many attempts"
                          }
                          this.$toasted.info(message, {duration: 3000})
                      }
                      if (e.status == 500) {
                          this.$toasted.error('an unexpected error occurred', {duration: 3000})
                      }
                  }.bind(this)
              })
              
          },
          scrollToNewestMessage () {
              this.$nextTick(function scrollToMessage() {
                  var count = document.getElementsByClassName(messageClassName).length
                  if (!count) return;
                  var scrollEl = document.getElementsByClassName(messageClassName)[count - 1]
                  if (scrollEl) scrollEl.scrollIntoView()
              })
          },

          scrollOrPromptNewMessage () {
            if (this.aboveMessageIndicatorWaypoint) {
                this.newMessageIndicatorPromptVisible = true
            } else {
                this.scrollToNewestMessage()
            }
          },

          selectMessage(message) {
                // if(!this.activeChatAdmin) return;
              if (this.selectedMessage == null) {
                  this.selectedMessage = message
              } else {
                  if (message.id == this.selectedMessage.id) {
                      this.selectedMessage = null
                  } else {
                      this.selectedMessage = message
                  }
              }
          },

          isMessageSelected(message) {
              if (this.selectedMessage) {
                  return this.selectedMessage.id == message.id
              }
              return false
          },

          pinMessage(message) {
            this.selectedMessage = message
            this.alertModal.type = message.action
            this.setAlertModalText()
            this.alertModal.active = true
            $(".global-chat-alert-container").show(0, function () {
                $(".global-chat-alert-modal").trigger('focus')
            })
          },

          flagMessage(message) {
              this.selectedMessage = message
              this.alertModal.type = 'flag'
              this.setAlertModalText()
              this.alertModal.active = true 
              $(".global-chat-alert-container").show(0, function () {
                  $(".global-chat-alert-modal").trigger('focus')
              })
          },

          handleDirectMessageFromMessage (message) {
            this.findOrCreateGlobalChatConnection(message.event_attendee_id)
          },


          directMessageRecipientIsBlocked () {
            return this.directMessageRecipient
                && this.directMessageRecipient.blocked_by_connections
                && this.directMessageRecipient.blocked_by_connections.length
          },
          
          setAlertModalText() {
            var modalType = this.alertModal.type
            modalType = (modalType === 'flag') ? 'delete' :
                (this.pinnedMessage && modalType !== 'unpin') ?'replace_pin' : modalType

            var title =  this.lang.get('event_strings.global-chat.'+modalType+'_message_title')
            var subtitle =  this.lang.get('event_strings.global-chat.'+modalType+'_message_subtitle')
            var confirmText =  this.lang.get('event_strings.global-chat.'+modalType+'_message_confirm')
            var cancelText =  this.lang.get('event_strings.global-chat.delete_message_cancel')

            this.alertModal.title = title
            this.alertModal.subtitle = subtitle
            this.alertModal.confirmText = confirmText
            this.alertModal.cancelText = cancelText
          },

          alertModalConfirm() {
            var room = this.rooms.find(r => r.id === this.activeRoomId)
            var type = this.alertModal.type
            if (!room || !type) { return }

            var data = type !== 'flag' ? { action: type } : {}
            if (type !== 'flag') type = 'pin'

            var url = `/api/v1/global-chat/${room.id}/message/${this.selectedMessage.id}/${type}`
              $.ajax({
                  url: url,
                  headers: this.ajaxHeaders,
                  data: data,
                  method: 'POST',
                  success: function (res) {
                    var message = res.data
                    if (type === 'flag') {
                        room.messages = room.messages.filter(function (msg) {
                            return msg.id != message.id
                        }.bind(this))
                    }
                    else {
                        room.messages.forEach(function(msg, key) {
                            msg.pinned = msg.id == message.id ? message.pinned : false
                        })
                    }
                    this.alertModal.active = false
                    this.selectedMessage = null
                  }.bind(this),
                  error: function (e) {
                      console.error('error', e)
                  }
              })

          },
          alertModalCancel() {
              this.alertModal.active = false
          },
          flagUnflagAttendee(eventAttendee) {
            if (this.activeChatRoom.flaggingInProgressIds.includes(eventAttendee.id)) { return }
            this.activeChatRoom.flaggingInProgressIds.push(eventAttendee.id)
            
            var isFlagged = this.isMemberFlagged(eventAttendee.id)
            var url = `/api/v1/global-chat/${this.activeChatRoom.id}/member/${eventAttendee.id}/${isFlagged ? 'unflag' : 'flag'}`

            if (isFlagged) {
                const index = this.activeChatRoom.flagged_attendees.indexOf(eventAttendee.id);
                if (index > -1) {
                    this.activeChatRoom.flagged_attendees.splice(index, 1);
                }
            } else {
                this.activeChatRoom.flagged_attendees.push(eventAttendee.id)
            }

            $.ajax({
                url: url,
                headers: this.ajaxHeaders,
                method: 'POST',
                success: function (res) {
                    this.activeChatRoom.flaggingInProgressIds = this.activeChatRoom.flaggingInProgressIds.filter(id => id != eventAttendee.id);
                }.bind(this),
                error: function (e) {
                    this.activeChatRoom.flaggingInProgressIds = this.activeChatRoom.flaggingInProgressIds.filter(id => id != eventAttendee.id);
                    
                    //revert change
                    if (!isFlagged) {
                        const index = this.activeChatRoom.flagged_attendees.indexOf(eventAttendee.id);
                        if (index > -1) {
                            this.activeChatRoom.flagged_attendees.splice(index, 1);
                        }
                    } else {
                        this.activeChatRoom.flagged_attendees.push(eventAttendee.id)
                    }
                    
                    var fullname = `${eventAttendee.attendee_fields.first_name} ${eventAttendee.attendee_fields.last_name}`
                    this.$toasted.error('Error updating flag for '+fullname, {duration: 3000})
                    console.error('error', e)
                }.bind(this)
          })
        },
          isMemberFlagged(id) {
            return this.activeChatRoom.flagged_attendees && this.activeChatRoom.flagged_attendees.includes(id)
          },

          toggleBlockFromDirectMessageSettings () {
            this.handleBlockEventAttendeeToggle(this.directMessageRecipient)
          },

          handleBlockEventAttendeeToggle (member) {
              if (this.blockConnectionFetching) return;
              this.blockConnectionFetching = true
              if (member.blocked_by_connections && member.blocked_by_connections.length) {
                  this.destroyBlockedConnection(member)
              } else {
                  this.createBlockedConnection(member)
              }
          },

          handleToggleBlockedConnectionFromMessage (message) {
            var eventAttendee = message && message.event_attendee
            if (!eventAttendee) return;

            eventAttendee.blocked_by_connections.length
                ? this.destroyBlockedConnection(eventAttendee)
                : this.createBlockedConnection(eventAttendee)
          },

          createBlockedConnection (member) {
              var data = {blocked_event_attendee_id: member.id}
              $.ajax({ 
                    method: 'POST',
                    url: '/api/v1/blocked_connections', 
                    data: data,
                    headers: this.ajaxHeaders, 
                    success: function successfullyBlockedConnection (res) {
                        this.blockConnectionFetching = false
                        // update chat room members if exists to show blocked text
                        if (this.activeChatRoom && this.activeChatRoom.members && this.activeChatRoom.members.length) {
                            this.activeChatRoom.members = this.activeChatRoom.members.map((m) => {
                                if (m.id == member.id) {
                                    var blocked_by_connections = { blocked_by_connections: [res] }
                                    m = Object.assign({}, m, blocked_by_connections)
                                }
                                return m
                            })
                        }
                        // update direct message room if exists to show blocked
                        this.rooms.forEach((room) => {
                            var isMemberRoom = room.global_chat_connection 
                                && room.global_chat_connection.other_event_attendee 
                                && room.global_chat_connection.other_event_attendee.id == member.id
                            if (isMemberRoom) {
                                if (!room.global_chat_connection.other_event_attendee.blocked_by_connections) {
                                    var otherEventAttendee = Object.assign({}, room.global_chat_connection.other_event_attendee, {blocked_by_connections: []})
                                    room.global_chat_connection.other_event_attendee = otherEventAttendee
                                }
                                room.global_chat_connection.other_event_attendee.blocked_by_connections.push(res)
                            }
                        })
                        // update individual messages to toggle correctly
                        if (this.activeChatRoom && this.activeChatRoom.messages && this.activeChatRoom.messages.length) {
                            this.activeChatRoom.messages.forEach(function markNewlyBlocked (message) {
                                if (message.event_attendee && message.event_attendee.id == res.blocked_event_attendee_id) {
                                    message.event_attendee.blocked_by_connections.push(res)
                                }
                            }.bind(this))
                        }

                    }.bind(this),
                    error: function errorBlockingConnection (err) {
                        this.$toasted.error('error blocking attendee', {duration: 2000})
                        this.blockConnectionFetching = false
                    }.bind(this)
                })
          },

          addRoomBlockedConnectionIfExists (blockedConnection) {
            this.rooms.forEach((room) => {
                var globalChatConnectionOtherMember = room.global_chat_connection && room.global_chat_connection.other_event_attendee 
                if (!globalChatConnectionOtherMember) return

                if (globalChatConnectionOtherMember.id == blockedConnection.blocked_event_attendee_id) {
                    room.global_chat_connection.other_event_attendee.blocked_by_connections.push(blockedConnection)
                }
            })
          },

          removeRoomBlockedConnectionIfExists (blockedConnection) {
            this.rooms.forEach((room) => {
                var globalChatConnectionOtherMember = room.global_chat_connection 
                    && room.global_chat_connection.other_event_attendee
                if (!globalChatConnectionOtherMember) return
                if (globalChatConnectionOtherMember.id == blockedConnection.blocked_event_attendee_id) {
                    room.global_chat_connection.other_event_attendee.blocked_by_connections = [];
                }
            })
          },

          destroyBlockedConnection (member) {
            var blockedConnection = member.blocked_by_connections[0]
            $.ajax({ 
                method: 'DELETE',
                url: `/api/v1/blocked_connections/${blockedConnection.id}`, 
                data: {}, 
                success: function successfullyDestroyedBlockedConnection (res) {
                    this.blockConnectionFetching = false
                    var activeChatRoomMembers = this.activeChatRoom && this.activeChatRoom.members && this.activeChatRoom.members.length
                    // update members panel to show newly unblocked status
                    if (activeChatRoomMembers) {
                        this.activeChatRoom.members = this.activeChatRoom.members.map((m) => {
                            if (m.id == member.id) {
                                var blocked_by_connections = { blocked_by_connections: [] }
                                m = Object.assign({}, m, blocked_by_connections)
                            }
                            return m
                        })
                    }

                    // update direct message rooms to show newly unblocked
                    this.rooms.forEach((room) => {
                        var isMemberRoom = room.global_chat_connection
                            && room.global_chat_connection.other_event_attendee
                            && room.global_chat_connection.other_event_attendee.id == member.id
                            
                        if (isMemberRoom) room.global_chat_connection.other_event_attendee.blocked_by_connections = []
                    })         
                    
                    // update messages to show blocked status
                    if (this.activeChatRoom && this.activeChatRoom.messages && this.activeChatRoom.messages.length) {
                        this.activeChatRoom.messages.forEach(function markNewlyunBlocked (message) {
                            if (message.event_attendee && message.event_attendee.id == res.blocked_event_attendee_id) {
                                message.event_attendee.blocked_by_connections = []
                            }
                        }.bind(this))
                    }

                }.bind(this),
                error: function errorDestroyingBlockingConnection (err) {
                    this.$toasted.error('error blocking attendee', {duration: 2000})
                    this.blockConnectionFetching = false
                }.bind(this)
            })
          },

          listenForDirectMessages () {
            var eventId = this.currentEventAttendee.event_id
            var eventAttendeeId = this.currentEventAttendee.id
            var channelName = `global_chat.event.${eventId}.direct_messages.${eventAttendeeId}`
            window.Echo.private(channelName).listen('GlobalChatRoomMessageCreated', function (data) {
                var message = attachMomentObjects(data.message)
                var room = this.rooms.find(r => r.id == message.global_chat_room_id)
                if (room) {
                    room.messages = [...room.messages, message]
                    this.updateNewestKnownMessageForRoom(message)
                    if (this.activeRoomId == room.id && this.activeChatroomTab == 'chat' && this.drawerVisible) {
                        this.$set(this.lastReadMessages, message.global_chat_room_id, message.id)
                        this.scrollOrPromptNewMessage()
                    }
                } else {
                    var globalChatRoomConnectionId = data.message
                        && data.message.global_chat_room
                        && data.message.global_chat_room.global_chat_connection_id
                    this.fetchGlobalChatConnection(globalChatRoomConnectionId)
                }
            }.bind(this))
          },

          updateNewestKnownMessageForRoom (message) {
            this.rooms.forEach(function (room) {
                if (room.id == message.global_chat_room_id) {
                    room.newestKnownMessageId = message.id
                    this.updateRoomHasUnreadMessage(room)
                }
            }.bind(this))
          },

          listenToNewMessageNotification (room) {
            var channelName = `global_chat.event.${room.event_id}.room.${room.id}.new_message`
            var pusherChannel = Echo.private(channelName).listen("GlobalChatRoomMessageCreated", function (data) {
                var message = data.message
                if (this.drawerVisible && this.activeRoomId === message.global_chat_room_id) { 
                    return 
                }
                this.updateNewestKnownMessageForRoom(message)
                pusherChannel.subscription.unsubscribe()
            }.bind(this))
            return pusherChannel
          },

          listenToRoomNotifications(room) {

            if (room.pusherChannel) {
                room.pusherChannel.subscription.subscribe()
                return
            }

              var channelName = `global_chat.event.${room.event_id}.room.${room.id}`
              var pusherChannel = Echo.private(channelName).listen("GlobalChatRoomMessageCreated", function (data) {
                var message = data.message
                if (message.flagged) {
                    room.messages = room.messages.filter(function filterFlaggedMessage (currMessage) {
                        return currMessage.id != message.id
                    })
                    return
                }
                if (message.pinned || this.pinnedMessage) {
                    var index = room.messages.findIndex(m => m.id == message.id);
                    if(index != -1 && room.messages[index]) {
                        room.messages[index].pinned = message.pinned
                        return
                    }
                }
                if (!this.drawerVisible || this[ACTIVE_CHAT_ROOM_TAB] != 'chat') {
                    this.updateNewestKnownMessageForRoom(message)
                } else {
                    this.$set(this.lastReadMessages, message.global_chat_room_id, message.id)
                }
                var exists = false
                for (var i = 0; i < room.messages.length; i++) {
                    if (room.messages[i].id == message.id) {
                        exists = true
                        break
                    }
                }
                if (exists) return;
                
                var updatedMessage = attachMomentObjects(message)
                room.messages.push(updatedMessage)
                var currentRoomMessage = this.activeRoomId && this.activeRoomId == message.global_chat_room_id
                if (!currentRoomMessage) return;
                this.scrollOrPromptNewMessage()
              }.bind(this))
              room.pusherChannel = pusherChannel

              var attendeeFlaggingChannel = `global_chat.event.${room.event_id}.room-attendee-flags.${room.id}`
              var flagsPusherChannel = Echo.private(attendeeFlaggingChannel).listen("GlobalChatRoomFlaggedEventAttendeeUpdated", function (data) {
                var flagStatus = data.event_attendee.status
                var eaId = parseInt(data.event_attendee.id)

                if(room.flagged_attendees.includes(eaId)) {
                    if (flagStatus == 'unflagged') {
                        const index = room.flagged_attendees.indexOf(eaId);
                        if (index > -1) {
                            room.flagged_attendees.splice(index, 1);
                        }
                    }
                } else {
                    if (flagStatus == 'flagged') {
                        room.flagged_attendees.push(eaId)
                    }
                }
              }.bind(this))

              room.flagsPusherChannel = flagsPusherChannel
          },
          testLocalStorage () {
            var test = 'test';
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                this.localStorageAvailable = true
            } catch(e) {
                return false;
            }
          },
          removeAllLocalStorage () {
            storedState.forEach(function (prop) {
                localStorage.removeItem(prop)
            })
          },

          clickBroadcastButton() {
            if (this.selectedBroadcastChatRooms.length > 0) {
                this.postBroadcastMessage()
            } else {
                this.broadcastChatRoomsPopupVisible = !this.broadcastChatRoomsPopupVisible
            }
          },

          postBroadcastMessage() {
            if (this.broadcastChatMessageSending) { return }

            if (this.broadcastChatMessageText.length < 1) {
                this.$toasted.error('Text cannot be empty', {duration: 3000})
                return
            }

            var roomIds = this.selectedBroadcastChatRooms.map(r => r.id)
            var message = this.broadcastChatMessageText
            var data = {'data': {
                'roomIds': roomIds,
                'message': message
            }}

            this.broadcastChatMessageSending = true

            $.ajax({
                url: '/api/v1/global-chat/broadcastMessage',
                headers: this.ajaxHeaders,
                data: data,
                method: 'POST',
                success: function (res) {
                    this.broadcastChatMessageSending = false
                    this.broadcastChatRoomsPopupVisible = false
                    this.$toasted.success(`Message sent to ${this.selectedBroadcastChatRooms.length} rooms`, {duration: 3000})
                    this.selectedBroadcastChatRooms.forEach(r => r.shouldBroadcastToRoom = false)
                    this.broadcastChatMessageText = ''
                }.bind(this),
                error: function (e) {
                    this.broadcastChatMessageSending = false
                    var errMessage = Object.keys(e.responseJSON.errors).reduce(function (acc, key) {
                        acc = acc + " " + e.responseJSON.errors[key]
                        return acc
                    }.bind(this), '')
                    this.$toasted.error(errMessage, {duration: 3000})
                    return
                }.bind(this)
            })
        },
          updateAllRoomsHasLastReadMessage () {
              this.rooms.forEach(this.updateRoomHasUnreadMessage)
          },

          updateLastReadMessageToNewest (roomId, opts={}) {
            var room = this.rooms.find(r => r.id == roomId)
            if (!room) return;
            var newestKnownMessageId = room.newestKnownMessageId
            // newest unflagged message
            var lastVisibleMessageId = room
                && room.messages
                && room.messages.length
                && room.messages.sort(sortMessagesById)[room.messages.length - 1].id

                var lastReadMessageId = lastVisibleMessageId

            // If a message has been created and flagged, we want that to be the last read message id
            if (newestKnownMessageId) {
                if (!lastReadMessageId || (newestKnownMessageId > lastReadMessageId))  {
                    lastReadMessageId = newestKnownMessageId
                }
            }
            this.$set(this.lastReadMessages, room.id, lastReadMessageId)
            if (opts.updateRemoteState) this.storeLastReadMessages()
          },

          handleNewMessageIndicatorClick () {
            this.newMessageIndicatorPromptVisible = false
            this.scrollToNewestMessage()
          },

          handleChatRoomScrolledBottom () {
            this.resetNewMessageIndicatorWaypoinState()
          },
          
          handleChatRoomScrolledUp () {
            this.aboveMessageIndicatorWaypoint = true
          },

          resetNewMessageIndicatorWaypoinState () {
            this.aboveMessageIndicatorWaypoint = false
            this.newMessageIndicatorPromptVisible = false
          },

          toggleSelectedUserForDirectMessage (member) {
              var currentMemberId = this.selectedUserForDirectMessage && this.selectedUserForDirectMessage.id
              if (currentMemberId && currentMemberId == member.id) {
                this.selectedUserForDirectMessage = null
              } else {
                this.selectedUserForDirectMessage = member
              }
              this.findOrCreateGlobalChatConnection()
          },

          isActiveChatListTab (tab) {
            return this.chatRoomListsActiveTab == tab
          },

          findOrCreateGlobalChatConnection (eventAttendeeId=null, readOnlyDatabaseHack=false) {

            var event_attendee_id = eventAttendeeId || this.selectedUserForDirectMessage.id

            if (this.activeChatRoom && this.activeChatRoom.members && this.activeChatRoom.members.length) {
                var foundMember = this.activeChatRoom.members.find((member) => member.id === event_attendee_id)
                if (foundMember && foundMember.blocked_by_connections && foundMember.blocked_by_connections.length) {
                    this.$toasted.error('unblock attendee to direct message', { duration: 4000 })
                    return
                }
            }

            if (this.fetchingCreateGlobalChatRoomConnection) return;

            this.fetchingCreateGlobalChatRoomConnection = true
                
            $.ajax({
                url: '/api/v1/global_chat_connections',
                method: 'POST',
                data: { event_attendee_id: event_attendee_id }, 
                success: function (res) {
                    // this is bad hack, need to discover why onWriteConnection fails for nested relationship in globalChatConnectionsController
                    // this will re run to get correct response and do set up then, needs to be fixed properly
                    if (readOnlyDatabaseHack) {
                        var globalChatRoomReturned = res.global_chat_connection && res.global_chat_connection.global_chat_room
                        if (!globalChatRoomReturned) {
                            this.findOrCreateGlobalChatConnection(event_attendee_id, false)
                            return
                        }
                    }
                    this.drawerVisible = true
                    this.selectedUserForDirectMessage = null
                    var room = this.reconfigureGlobalChatRoomConnection(res.global_chat_connection)
                    var newRoom = this.decorateRoom(room)
                    var foundRoom = this.rooms.find(r => newRoom.id == r.id)
                    if (!foundRoom) this.rooms.push(newRoom)
                    this.activeRoomId = newRoom.id
                    this.activeChatroomTab = 'chat'
                }.bind(this),
                error: function (err) {
                    var errMessage = 'an error occurred'
                    if (err && err.responseJSON && err.responseJSON.message) {
                        errMessage = err.responseJSON.message
                    }
                    this.$toasted.error(errMessage, {duration: 4000})
                }.bind(this),
                complete: function () {
                    this.fetchingCreateGlobalChatRoomConnection = false
                }.bind(this)
            })
          },

          destroyGlobalChatConnection (globalChatConnection) {
            $.ajax({
                url: `/api/v1/global_chat_connections/${globalChatConnection.id}`,
                method: 'DELETE',
                data: {},
                success: function (res) {
                    this.$toasted.show(res.message)
                }.bind(this),
                error: function (err) {
                    this.$toasted.error(error)
                }.bind(this)
            })
          },

          reconfigureGlobalChatRoomConnection (globalChatConnection) {
            var globalChatRoom = Object.assign({}, globalChatConnection.global_chat_room)
            var globalChatConnectionData = Object.keys(globalChatConnection).reduce(function rebuildGlobalChatRoom (acc, k) {
                if (k == 'global_chat_room') return acc
                acc[k] = globalChatConnection[k]
                return acc
            }, {})
            globalChatRoom.global_chat_connection = globalChatConnectionData
            globalChatRoom.global_chat_connection.other_event_attendee = globalChatRoom.global_chat_connection.event_attendees.find(ea => ea.id !== this.currentEventAttendee.id)
            globalChatRoom.messages = []
            if (globalChatRoom.latest_message) globalChatRoom.messages.push(globalChatRoom.latest_message)
            return globalChatRoom
          },

          fetchGlobalChatConnection (id) {
            $.ajax({
                url: `/api/v1/global_chat_connections/${id}`,
                method: 'GET',
                success: function (res) {
                    var room = this.reconfigureGlobalChatRoomConnection(res.global_chat_connection)
                    var newRoom = this.decorateRoom(room)
                    this.rooms.push(newRoom)
                }.bind(this),
                error: function (err) {
                    this.initialFetches.direct_messages = true
                    console.error('error fetching global chat connection')
                    // this.$toasted.error('error updating', {duration: 4000})
                }.bind(this)
            })  
          },

          fetchGlobalChatConnections () {
            $.ajax({
                url: '/api/v1/global_chat_connections',
                method: 'GET',
                success: function (res) {
                    var globalChatConnections = res.data
                    var globalChatRooms = globalChatConnections.map(this.reconfigureGlobalChatRoomConnection)
                    this.direct_message_rooms_paginator = res
                    var newRooms = globalChatRooms.map(this.decorateRoom)
                    this.direct_message_rooms = newRooms
                    newRooms.forEach(r => this.rooms.push(r))   
                    this.initialFetches.direct_messages = true
                }.bind(this),
                error: function (err) {
                    console.error('error fetching global chat connections')
                    // this.$toasted.error('error updating', {duration: 4000})
                    this.initialFetches.direct_messages = true
                }.bind(this)
            })              
          },

          getNextGlobalDirectChatConnections: function() {
            var paginator = this.direct_message_rooms_paginator
            if (!paginator) return;
            var nextPageUrl = paginator.next_page_url
            if (!nextPageUrl) return
            if (this.fetchingGlobalRooms) return;
            this.fetchingGlobalRooms = true
            $.ajax({
                url: nextPageUrl,
                headers: this.ajaxHeaders,
                method: 'GET',
                success: function (res) {
                    var globalChatConnections = res.data
                    var globalChatRooms = globalChatConnections.map(this.reconfigureGlobalChatRoomConnection)
                    this.direct_message_rooms_paginator = res
                    var newRooms = globalChatRooms.map(this.decorateRoom)
                    newRooms.forEach(r => this.rooms.push(r))   
                    this.direct_message_rooms = newRooms
                    this.fetchingGlobalRooms = false
                }.bind(this),
                error: function (e) {
                    this.fetchingGlobalRooms = false
                    console.error('error', e)
                }
            })
          },

          hasAnyUnreadGroupMessages: function () {
            var unreadMessages = false
            this.groupChatRooms.forEach((room) => {
                if (room.hasUnreadMessage) unreadMessages = true
            })
            return unreadMessages
          },

         hasAnyUnreadMessages: function() {
            var unreadMessages = this.rooms.some(room => room.hasUnreadMessage);
            $('.nav-global-chat-button').toggleClass('has-unread-chat-messages', unreadMessages);
            return unreadMessages;
         },

          hasAnyUnreadDirectMessages: function () {
            var unreadMessages = false
            this.directMessageRooms.forEach((room) => {
                if (room.hasUnreadMessage) unreadMessages = true
            })
            return unreadMessages
          },

          focusTrap: function() {
            const self = this
            document.addEventListener('keydown', (e) => {
                if (e.key !== 'Tab') return;
                const target = $(e.target);
                if (self.drawerVisible && !self.currentEvent.is_base_style) {
                    if (target.closest(".global-chat").length === 0 || (target.hasClass("global-chat__send-button") &! e.shiftKey) || (target.closest(".chat-list-room:last-child").length > 0 && target.hasClass("chat-list-room__lasst-message-time") &! e.shiftKey)) {
                        $(".global-chat__toggle").focus()
                        e.preventDefault();
                    }
                    if (target.hasClass('global-chat__toggle') || (target.hasClass('fa-chevron-left') && $('.global-chat__toggle').length == 0)) {
                        if (e.shiftKey) {
                            if ($(".global-chat__send-button").length > 0) {
                                $(".global-chat__send-button").focus()
                            } else if ($(".chat-list-room__content_right > div").length > 0) {
                                $(".chat-list-room__content_right > div").focus()
                            } else if ($(".global-chat-active-attendees-list__attendee-item").length > 0) {
                                $(".global-chat-active-attendees-list__attendee-item").focus()
                            } else if ($("#global-chat-search").length > 0) {
                                $("#global-chat-search").focus();
                            } else {
                                $(".global-chat-list__header").focus()
                            }
                            e.preventDefault()
                        } 
                    }
                } else if (self.drawerVisible && self.currentEvent.is_base_style) {
                    if (target.hasClass('global-chat__toggle') || ((target.hasClass('fa-chevron-left') || target.hasClass('global-chat-list__header')) && $('.global-chat__toggle:visible').length == 0)) {
                        if (e.shiftKey) {
                            if ($(".global-chat__send-button").length > 0) {
                                $(".global-chat__send-button").focus()
                            } else if ($(".chat-list-room__content_right > div").length > 0) {
                                $(".chat-list-room__content_right > div").focus()
                            } else if ($(".global-chat-active-attendees-list__attendee-item").length > 0) {
                                $(".global-chat-active-attendees-list__attendee-item").focus()
                            } else if ($("#global-chat-search").length > 0) {
                                $("#global-chat-search").focus();
                            } else {
                                $(".global-chat-list__header").focus()
                            }
                            e.preventDefault()
                        } 
                    } else if ((target.closest(".global-chat").length === 0 || (target.hasClass("global-chat__send-button")) || (target.closest(".chat-list-room:last-child").length > 0 && target.hasClass("chat-list-room__lasst-message-time"))) && !e.shiftKey) {
                        if ($(".global-chat__toggle:visible").length > 0) {
                            $(".global-chat__toggle").focus()
                        } else if ($(".global-chat-list__header").length > 0) {
                            $(".global-chat-list__header").focus()
                        } else {
                            $(".global-chat__back-button")[0].focus();
                        }
                        e.preventDefault();
                    }
                }
                if (((target.hasClass("btn-global-chat-search") && $(".global-chat-active-attendees-list__attendee-item").length == 0) || ($(".global-chat-active-members-holder").children().last()[0] == target[0])) && !e.shiftKey) {
                    if ($(".global-chat__toggle:visible").length > 0) {
                        $(".global-chat__toggle").focus()
                    } else if ($(".global-chat-list__header").length > 0) {
                        $(".global-chat-list__header").focus()
                    } else {
                        $(".global-chat__back-button")[0].focus();
                    }
                    e.preventDefault();
                }
            })
          },
      }
  })
  return vueCtrl
}

export default GlobalChatController

// fetchServerTime () {
//   this.fetchingServerTime = true
//   $.ajax({
//       url: '/event_attendee_presence/server_time',
//       headers: {
//           'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
//           'Content-Type': 'application/x-www-form-urlencoded'
//       },
//       method: 'GET',
//       success: function (res) {
//           this.serverTime = new moment(res)
//           this.fetchingServerTime = false
//           if (this.drawerVisible) {
//               this.fetchServerTimeOnTimeout()
//           }
//       }.bind(this),
//       error: function (err) {
//           this.fetchingServerTime = false
//           if (this.drawerVisible) {
//               this.fetchServerTimeOnTimeout()
//           }
//       }.bind(this)
//   })
// },

// fetchServerTimeOnTimeout () {
//   if (this.fetchingServerTimeTimeoutId) window.clearTimeout(this.fetchingServerTimeTimeoutId)
//   this.fetchingServerTimeTimeoutId = window.setTimeout(this.fetchServerTime, 10000)
// },          

//   listenForAttendeeLastActiveUpdates () {
//     var eventId = this.currentEventAttendee.event_id
//     var channelName = `event-attendee-online.event.${eventId}`
//     window.Echo.private(channelName).listen('EventAttendeeLastActiveUpdated', function (data) {
//         var momentObject = new moment(data.event_attendee.last_active)
//         if (!this.attendeesLastActive[data.event_attendee.id]) {
//             Vue.set(this.attendeesLastActive, data.event_attendee.id, momentObject)
//         } else {
//             this.attendeesLastActive[data.event_attendee.id] = momentObject
//         }
//     }.bind(this))
//   },

// setPaddingFromHeader () {
//     if (!document.getElementById('nav-top-navigation')) return
//     if (!this.drawerVisible) return
//     if (window.innerWidth < 896) {
//         $('#attendeeWeb .global-chat').css('padding-top', '0px');
//     } else {
//         var topNavHeight = $('#nav-top-navigation').outerHeight()
//         if(topNavHeight) $('#attendeeWeb .global-chat').css('padding-top', topNavHeight+'px');
//     }
//   },